import { render, staticRenderFns } from "./Quitters.vue?vue&type=template&id=dd7e814a&"
import script from "./Quitters.vue?vue&type=script&lang=js&"
export * from "./Quitters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports